<template>
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">Importar Compromissos</h1>
  
        <!-- Seleção do período -->
        <div class="form-group col-sm-4">
          <label class="custom-font">Período</label>
          <select class="form-control" v-model="periodo">
            <option disabled value="">Selecione o período</option>
            <option v-for="p in periodos" :key="p" :value="p">{{ p }}</option>
          </select>
        </div>
  
        <!-- Upload do CSV -->
        <div class="form-group col-sm-8">
          <label class="custom-font">Arquivo CSV</label>
          <input ref="file" type="file" class="form-control" accept=".csv" @change="handleFile" />
        </div>
  
        <!-- Tabela de pré-visualização -->
        <div class="col-xs-12" v-if="compromissos.length">
          <h3>Pré-visualização</h3>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Unidade</th>
                <th>Compromisso</th>
                <th>Responsável</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in compromissos" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.unidade_executora }}</td>
                <td>{{ item.descritivo }}</td>
                <td class="text-center">{{ item.responsavel_sshd }}</td>
              </tr>
            </tbody>
          </table>

          <div class="button-wrapper">
            <button class="btn btn-default" @click="salvar">
                <font-awesome-icon :icon="'save'" /> Importar
            </button>
          </div>
  
        </div>
      </div>
    </div>
  </template>

<script>
import Papa from 'papaparse' 
import { request } from '@/request'

export default {
  name: 'compromisso-importar',
  data() {
    return {
      periodo: '',
      periodos: ['2025-2028'],
      compromissos: [],
      unidades: [],
    }
  },
  methods: {
    async extrairUnidades() {
      if (!this.compromissos.length) {
        this.unidades = [];
        return;
      }

      const uniqueUnidades = [...new Set(this.compromissos.map(item => item.unidade_executora))];

      try {
        const { data, status } = await request.get('unidade-organizacional/siglas', {
          params: { siglas: uniqueUnidades }
        });

        if (status !== 200) {
            this.$toastr.e('Não foi possível buscar os nomes das unidades.');
            return;
        }

        const unidadesMap = new Map(data.map(unidade => [unidade.sigla, unidade.nome]));

        this.compromissos = this.compromissos.map(compromisso => {
          const nomeUnidade = unidadesMap.get(compromisso.unidade_executora);

          return {
            ...compromisso,
            nome_unidade_executora: nomeUnidade || compromisso.unidade_executora
          };
        });

      } catch (err) {
        console.error('Falha ao buscar unidades:', err);
        this.$toastr.e('Ocorreu um erro ao validar as unidades no servidor.');
      }
    },
    handleFile(event) {
      const file = event.target.files[0]
      if (!file) return

      this.reset(); 

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          this.compromissos = result.data.map(row => ({
            unidade_executora: row['unidade'],
            descritivo: row['compromisso'],
            responsavel_sshd: row['responsavel']
          }))
          this.extrairUnidades();
        }
      })
    },
    reset() {
      this.periodo = '',
      this.$refs.file.value = ''
      this.compromissos = []
      this.unidades = []
    },
    async salvar() {
      if (!this.periodo || !this.compromissos.length) {
        this.$toastr.e('Selecione o período e carregue um arquivo válido.')
        return
      }

      const { periodo, compromissos } = this
      const { status } = await request.post('planogoverno/compromisso', { periodo, compromissos })

      if (status != 201) return this.$toastr.e('Houve um problema na importação dos compromissos, tente novamente daqui a pouco!')

      this.$toastr.s('Compromissos importados com sucesso.')
      this.reset()
    },
  }
}
</script>

<style scoped>
.custom-font {
  color: #00615c;
  font-weight: bold;
}
.page-header {
  margin-top: 20px;
}

.button-wrapper {
    width: 100%;
    display:flex;
    justify-content: right;
}
</style>
  


// WEBPACK FOOTER //
// src/views/admin/plano-governo/compromisso/Importar.vue